import { render } from "./VerificationSection.vue?vue&type=template&id=2880d971&scoped=true"
import script from "./VerificationSection.vue?vue&type=script&lang=js"
export * from "./VerificationSection.vue?vue&type=script&lang=js"

import "./VerificationSection.vue?vue&type=style&index=0&id=2880d971&lang=postcss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2880d971"]])

export default __exports__